<cost-optimization-ftr
  *ngIf="selected"
  [type]="selected"
></cost-optimization-ftr>
